export default __webpack_public_path__ + "static/main-logo-2456a3cefc79785a07076fe4e1408b61.png";